import React from "react";

import AddTab from "../../tabs/components/add-tab";
import { useNutritionPanels } from "./nutritionpanel/hooks/use-nutrution-panels";
import { useNutritionPanelState } from "./nutritionpanel/hooks/use-nutrition-panel-state";

export const NewPanelTabs = ({ label, readOnly, selectedIndex, onMovePanel }) => {
    const { state } = useNutritionPanelState();
    const { addPanel: addTab, changeTab } = useNutritionPanels();
    const tabs = state.panels;
    const hasActivePanels = tabs.length > 1;

    const tabsHtml = tabs.map((tab, index) => {
        const tabName = tab.text || `Panel ${index + 1}`;
        const tabClass = index === Number(selectedIndex) ? "tab -active" : "tab";

        return (
            <button
                key={`tab_${index}`}
                data-index={index}
                className={tabClass}
                onClick={() => {
                    changeTab(index);
                }}
            >
                {tabName}
            </button>
        );
    });

    return (
        <div className="tab-container">
            <div className="tab-list -thick justify-content-between">
                {hasActivePanels && (
                    <div className="justify-content-end m-b-10">
                        <button
                            className="button -small"
                            onClick={onMovePanel}
                        >
                            Move Nutrition Panel Column
                        </button>
                    </div>
                )}
                <div className="flex">
                    {tabsHtml}
                    {!readOnly && (
                        <AddTab
                            addTab={addTab}
                            label={label}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

NewPanelTabs.defaultProps = {
    label: "Panel",
};
